<template>
  <div id="Report" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">R</span>eport</div>
        <div class="col-3 t-r f26"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12 lh36 pl10 pr10 f14 bg-color-white uppercase bb1">
      <div class="col-12 t-c" @click="timeCh()">
        <span v-if="$store.state.app_args.report_date == 1">Hoy</span>
        <span v-else-if="$store.state.app_args.report_date == 2">Ayer</span>
        <span v-else-if="$store.state.app_args.report_date == 3">Esta semana</span>
        <span v-else-if="$store.state.app_args.report_date == 4">Este mes</span>
        <span v-else-if="$store.state.app_args.report_date == 5">La semana pasada</span>
        <span v-else-if="$store.state.app_args.report_date == 6">El mes pasado</span>
        <span v-else-if="$store.state.app_args.report_date == 7">últimos 7 días</span>
        <span v-else-if="$store.state.app_args.report_date == 8">últimos 30 días</span>
        <span v-else-if="$store.state.app_args.report_date == 9">últimos 90 días</span>
      <i class="iconfont icon-arrow-down-filling color-muted"></i></div>
      <!--
      <div class="col-4 t-c" :class="{'bb3-primary color-primary fw':report_type == 1,'color-muted':report_type != 1}" @click="typeCh(1)">Ventas</div>
      <div class="col-4 t-c" :class="{'bb3-primary color-primary fw':report_type == 2,'color-muted':report_type != 2}" @click="typeCh(2)">TOP</div>
      -->
    </div>
    <div class="col-12 pl5 pr5 bg-color-white f14">
      <div class="col-12 lh38 bb1">
        <div class="col-6 color-muted">
          Nueva principal
        </div>
        <div class="col-6 t-r">{{point_log_report['activation_now_count_1']}}</div>
      </div>
      <div class="col-12 lh38 bb1">
        <div class="col-6 color-muted">
          Nueva Extensión
        </div>
        <div class="col-6 t-r">{{point_log_report['activation_now_count_2']}}</div>
      </div> 
      <div class="col-12 lh38 bb1">
        <div class="col-6 color-muted">
          Reinstalar principal
        </div>
        <div class="col-6 t-r">{{point_log_report['reinstall_now_count_1']}}</div>
      </div>
      <div class="col-12 lh38 bb1">
        <div class="col-6 color-muted">
          Reinstalar Extensión
        </div>
        <div class="col-6 t-r">{{point_log_report['reinstall_now_count_2']}}</div>
      </div> 
      <div class="col-12 lh38 bb1">
        <div class="col-6 color-muted">
          Renovar
        </div>
        <div class="col-6 t-r">{{point_log_report['renew_now_count']}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Report',
  data () {
    return {
      aid: '',
      points: '',
      pageData: {},
      Report_log_list: [],
      recharge: false,
      point_log_report: {}
    }
  },
  created: function () {
    this.aid = this.$route.query.aid;
    this.get_pageData();

  },
  methods: {
    get_pageData: function () {
      let post_data = {}
      post_data.aid = this.aid;
      post_data.time_type = this.$store.state.app_args.report_date;
      this.post(this.api_url + 'Agent/tec_report',post_data,true).then((res)=>{
        if(res.status == 1){
          this.point_log_report = res.data.point_log_report;
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    get_Report_log: function () {
      let post_data = {}
      post_data.aid = this.aid;
      this.post(this.api_url + 'Agent/Report_log',post_data,true).then((res)=>{
        if(res.status == 1){
          this.Report_log_list = res.data;
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    go_recharge: function () {
      if(this.recharge){
        this.recharge = false;
      }else{
        this.recharge = true;
      }
    },
    recharge_now: function () {
      let post_data = {}
      post_data.aid = this.aid;
      post_data.points = this.points;
      this.post(this.api_url + 'Agent/recharge_now',post_data,true).then((res)=>{
        this.recharge = false;
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Success"});
          this.get_pageData();
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    timeCh: function () {
      this.$router.push({name:'A_TimeSelect'});
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Agent/Report.vue